import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import queryString from 'query-string';
import Button from 'react-toolbox/lib/button';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import validateData from '../../common/utils/validations';

import styles from './AddVideo.scss';
import Error from '../ErrorMessage/Error';

// to import local scss fle

class AddVideo extends Component {
  static propTypes = {
    videoDetails: PropTypes.func,
    profileId: PropTypes.string.isRequired,
  };

  static defaultProps = {
    videoDetails: () => {},
    profileId: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      title: '',
      url: '',
      titleErrorMessage: '',
      urlErrorMessage: '',
    };
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false, urlErrorMessage: '', titleErrorMessage: '' });
  };

  handleChange = (name, errorMessage, value) => {
    this.setState({ ...this.state, [name]: value.target.value, [errorMessage]: '' });
  };

  saveVideoDetails = () => {
    const query = queryString.parse(this.state.url);
    let thumbImage = 'https://media.dev.myrecruitboard.com/Images/videoThumbnail.png';
    if (query && Object.prototype.hasOwnProperty.call(query, 'https://www.youtube.com/watch?v')) {
      thumbImage = `https://img.youtube.com/vi/${query['https://www.youtube.com/watch?v']}/0.jpg`;
    }
    const video = {
      id: this.props.profileId,
      video_url: this.state.url,
      video_title: this.state.title,
      thumbnail_url: thumbImage,
    };
    const validation = validateData(video);
    if (validation.urlIsValid && validation.titleIsValid) {
      this.setState({ open: false, title: '', urlErrorMessage: '', titleErrorMessage: '' });
      this.props.videoDetails(video);
    } else {
      this.setState({
        urlErrorMessage: validation.urlErrorMessage,
        titleErrorMessage: validation.titleErrorMessage });
    }
  };

  render() {
    const modalStyle = {
      width: '100%',
      padding: '0',
    };
    const { open, titleErrorMessage, urlErrorMessage } = this.state;
    return (
      <div>
        <Button icon="+" label="ADD VIDEOS" onClick={this.onOpenModal} flat primary />
        <Modal modalStyle={modalStyle} open={open} onClose={this.onCloseModal} little>
          <div className={cn('row')}>
            <div className={cn('col s12', styles.removePadding)}>
              <div className={cn('col s12', styles.videoHeader)}>
                <span>Add your videos here</span>
              </div>
              <div className={styles.inputFields}>
                <input type="text" placeholder="Enter Video title" onChange={val => this.handleChange('title', 'titleErrorMessage', val)} /> <br />
                <Error message={titleErrorMessage} />
                <input type="text" placeholder="Enter Video Url" onChange={val => this.handleChange('url', 'urlErrorMessage', val)} /> <br />
                <Error message={urlErrorMessage} />
                <div className={cn('col s12', styles.buttonContainer)}>
                  <button onClick={this.saveVideoDetails}>Submit</button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default AddVideo;



// WEBPACK FOOTER //
// ./src/components/AddVideos/AddVideo.js